import React, {Component} from 'react'
import fire from '../../../database/firebase'
import styled from 'styled-components'
import ClipLoader from "react-spinners/ClipLoader";

const Styles = styled.div `

    // - - POPUP - - //

.popup {
    width: 20%;
    position: fixed;
    top: 20px;
    right: 20px;
    background-color: white;
    padding: 20px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
    border-radius: 5.5px;
    z-index: 9999; /* Make sure it's on top */
}
  
.popup-content {
    /* Add additional styles for the popup content if needed */
}
  
.close {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
}

.popup h3 {
    text-align: left;
    font-family: arvo;
    color: black;
}

.popup p {
    text-align: left;
    font-family: gabarito;
    color: #0930cb;
    // font-weight: bold;
    font-size: 19px;
}

    // - - POPUP LOADING - - //

.pointsSectionLoading4 {
    padding-top: 1%;
    padding-bottom: 1%;
    // margin: auto;
    text-align: center;
    // margin-top: 1%;
    // border-bottom: 1px solid #0930cb;
}

    // - - POPUP DELETE BUTTON - - //

.popupBtn {
    text-align: right;
}

.popupBtn button {
    background-color: #DA2323;
    color: white;
    padding: 3%;
    width: 35%;
    border-radius: 6.5px;
    border: 2px solid transparent;
    font-family: arvo;
    font-weight: bold;
    cursor: pointer;
}

    // - - POPUP BTN CLOSE - - //



    // - - DELETE CONFIRMATION BUTTONS - - //

.deleteConfirmationBtns {
    display: flex;
    justify-content: space-between;
}

.leftCancelBtn {
    background-color: #fff;
    color: #0930cb;
    padding: 3%;
    width: 35%;
    border-radius: 6.5px;
    border: 2px solid #0930cb;
    font-family: arvo;
    font-weight: bold;
    cursor: pointer;
}

.rightCancelBtn {
    background-color: #0930cb !important;
    color: #fff;
    padding: 3%;
    width: 35%;
    border-radius: 6.5px;
    border: 2px solid #0930cb;
    font-family: arvo;
    font-weight: bold;
    cursor: pointer;
}

`

export default class PopupRewards extends Component {
    constructor (props) {
        super(props) 
        this.state = {
            popupTxt: "Delete selected items(s)",
            isPopup2Visible: false,
            showSelectedPolicyCounter: true,
            showDeletedConfirmationMsg: false,
            showDeleteBtn: true,
            showCloseBtn: false,
            showDeleteConfirmationBtns: false
            
        }
    }

    togglePopup = () => {
        this.setState((prevState) => ({
          isPopup2Visible: prevState.isPopup2Visible,
          showDeleteBtn: true,
          popupTxt: "Delete selected item(s)",
          showDeleteConfirmationBtns: false,
          showDeletingPretext: false
        }));
        if (this.props.selectedRewardsCount == 0) {
            this.setState({
                showDeleteBtn: true,
                popupTxt: "Delete selected item(s)"
            })
        }
    };

    loadDeleteConfirmationBtns = () => {
        this.setState({
            showDeleteBtn: false,
            showLoadingConfirmationBtns: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showLoadingConfirmationBtns: false,
                    showDeleteConfirmationBtns: true,
                    showDeletingPretext: true,
                    popupTxt: "Are you sure?"
                })
            }, 2000)
        })
    }

    confirmDeleteSelectedPolicies = () => {
        if (!this.props.selectedRewardsDeleting.length == 0) {
            for (var i = 0; i < this.props.selectedRewardsDeleting.length; i++) {
                fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("points")
                .collection("rewards")
                .doc("rewardsList")
                .collection("list")
                .doc(this.props.selectedRewardsDeleting[i])
                .delete()

                fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("points")
                .collection("rewards")
                .doc("rewardsList")
                .collection("rewardsDeleting")
                .doc(this.props.selectedRewardsDeleting[i])
                .delete()
            }
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("points")
            .collection("rewards")
            .doc("rewardsList")
            .update({
                selectedRewardsCount: 0
            })
            this.setState({
                popupTxt: "Are you sure?",
                showDeleteBtn: false,
                showDeleteConfirmationBtns: false,
                showLoadingConfirmationBtns: true
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showLoadingConfirmationBtns: false,
                        popupTxt: "Successfully deleted."
                    })
                    this.handleDeleteUIChange()
                }, 500)
            })
        } else {
            this.setState({
                popupTxt: "No items selected to delete"
            })
        }
    }

    cancelDeleteClicked = () => {
        this.setState({
            showDeleteConfirmationBtns: false,
            showDeletingPretext: false,
            popupTxt: "Delete selected items",
            showLoadingConfirmationBtns: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showLoadingConfirmationBtns: false,
                    showDeleteBtn: true,
                })
            }, 2000)
        })
    }

    handleDeleteUIChange = () => {
        this.props.onChildDelete();

    };

    render () {
        const { togglePopup } = this.props;

        return (
            <Styles>
                <div className="popup">
                    <div className="popup-content">
                        <span className="close" onClick={togglePopup}>
                            &times;
                        </span>
                        <h3>{this.state.popupTxt}</h3>
                        {this.state.showSelectedPolicyCounter && 
                            <p>{this.state.showDeletingPretext && <label>Deleting </label>}({this.props.selectedRewardsCount}) selected rewards</p>
                        }
                        {this.state.showDeletedConfirmationMsg && 
                            <p>Deletion was successful!</p>
                        }
                        {this.state.showDeleteBtn && 
                            <div className='popupBtn'>
                                <button
                                onClick={this.loadDeleteConfirmationBtns}
                                >Delete</button>
                            </div>
                        }
                        {this.state.showCloseBtn && 
                            <div className='popupBtn'>
                                <button
                                className='rightCancelBtn'
                                onClick={this.togglePopup}
                                >Close</button>
                            </div>
                        }
                        {this.state.showLoadingConfirmationBtns && 
                            <div className='pointsSectionLoading4'>
                                <ClipLoader
                                    color="#0930CB"
                                    loading={true}
                                    // cssOverride={override}
                                    size={15}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                />
                            </div>
                        }
                        {this.state.showDeleteConfirmationBtns && 
                            <div className='deleteConfirmationBtns'>
                                <button 
                                onClick={this.cancelDeleteClicked}
                                className='leftCancelBtn'>Cancel</button>
                                <button 
                                onClick={this.confirmDeleteSelectedPolicies}
                                className='rightCancelBtn'>Delete</button>
                            </div>
                        }
                    </div>
                </div>
            </Styles>
        )
    }
}